import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=2006409a&scoped=true"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"
import style0 from "./styles/comment-item.css?vue&type=style&index=0&id=2006409a&prod&scoped=true&lang=css&external"
import style1 from "./styles/comment-shared.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2006409a",
  null
  
)

export default component.exports